import { render, staticRenderFns } from "./NonPatientDetailsForm.vue?vue&type=template&id=45ddbc30&"
import script from "./NonPatientDetailsForm.vue?vue&type=script&lang=js&"
export * from "./NonPatientDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports